import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Image, Stack, Text, rem } from '@mantine/core';
import { AuthModalLayout } from './AuthModalLayout';
export const VerifyPasswordModal: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <AuthModalLayout opened={openModal === MODAL.VERIFY_PASS} handleClose={() => setOpenModal(null)}>
      <Stack justify="center" align="center" h="100%" mx="auto" gap={10} w={{
      base: '100%',
      sm: 524,
      xl: 427
    }} pb={{
      base: 268,
      md: 370,
      lg: 254
    }}>
        <Image src="/assets/kyc/mail_box.svg" alt="mail-box" w={{
        base: 128,
        sm: 164,
        lg: 180
      }} h={{
        base: 128,
        sm: 164,
        lg: 180
      }} />
        <Text fz={{
        base: 21,
        sm: 36,
        lg: 25
      }} lh={{
        base: rem(21),
        sm: rem(36),
        lg: rem(25)
      }} className={gunterzBold.className} c="var(--text-prime)" ta="center">
          {i18n._('Check your inbox!')}
        </Text>
        <Text w={368} fz={{
        base: 10,
        sm: 13
      }} tt="uppercase" ta="center" fw={700} c="var(--text-dark)">
          {i18n._('we’ve sent you a reset link. Follow it to regain access and continue your journey!')}
        </Text>
      </Stack>
    </AuthModalLayout>;
};